export enum MainLayoutSectionSection {

	SECTION_TOPBAR = 'SECTION_TOPBAR',
	SECTION_TOPBAR_NOT_FIXED = 'SECTION_TOPBAR_NOT_FIXED',
	SECTION_MAIN = 'SECTION_MAIN',
	SECTION_FOOTER = 'SECTION_FOOTER'

}
